import { createTheme } from '@mui/material/styles';

export const defaultThemeMode = 'dark';

const status = {
  pending: '#EEAE00',
  'in progress': '#009DB0',
  closed: '#FF2D55',
  rejected: '#FF2D55',
  duplicate: '#FF2D55',
  open: '#20D356',
};

const sharedPalette = {
  error: {
    main: '#DD4952',
  },
  warning: {
    main: '#FFA726',
  },
  info: {
    main: '#A4A4A4',
    contrastText: '#FFFFFF',
  },
  success: {
    main: '#66BB6A',
  },
  green: {
    main: '#009DB0',
  },
  status,
};

const variants = {
  dark: {
    primary: {
      main: '#002B45',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#FFFFFF',
      contrastText: '#FFFFFF',
    },
    white: {
      main: '#FFFFFF',
      contrastText: '#0F172B',
    },
    blue: {
      main: '#155DFC',
      contrastText: '#FFFFFF',
    },
    student: {
      main: '#002B45',
    },
    sideMenu: {
      main: '#155DFC',
      contrastText: '#FFFFFF',
    },
    colors: {
      red: '#FF2D55',
      white: '#FFFFFF',
      black: '#000000',
      border: 'rgba(0, 0, 0, 0.08)',
      borderStrong: 'rgba(209, 213, 220, 0.28)',
      lightBlue: '#CCD8ED',
      grey: '#4C4C4C',
      backgroundgrey: '#F7F7F7',
      inputbackground: '#F7F7F7',
      lightgrey: '#A4A4A4',
      bluestrong: '#194058',
      shadow: 'rgba(0,0,0,.16)',
      shadowLift: 'rgba(0, 0, 0, 0.42)',
      lightshadow: 'rgba(112,112,112,.06)',
      light: 'rgba(255, 255, 255, 0.10)',
      blueopacity: 'rgba(0, 43, 69, 0.8)',
      background: '#020618',
      backgroundTransparent: 'rgba(2, 6, 24, 0)',
      backgroundSoft: 'rgba(2, 6, 24, 0.8)',
      backgroundStrong: 'rgba(2, 6, 24, 0.95)',
      surface: '#1D293D',
      surfaceSoft: 'rgba(29, 41, 61, 0.72)',
      surfaceElevated: '#111C2F',
      surfaceElevatedSoft: 'rgba(17, 28, 47, 0.82)',
      surfaceElevatedStrong: '#0B1424',
      cardSurface: '#10253A',
      controlSurface: '#0A1628',
      summarySurface: '#0D1C30',
      chipSurface: '#122238',
      cardBorder: 'rgba(142, 174, 201, 0.24)',
      text: '#FFFFFF',
      muted: '#D1D5DC',
      subdued: '#99A1AF',
      contrast: '#0F172B',
      borderSoft: 'rgba(209, 213, 220, 0.18)',
      shadowStrong: 'rgba(0, 0, 0, 0.35)',
      cardShadow: '0 8px 24px rgba(0, 0, 0, 0.35)',
      shellGradientStart: 'rgba(21, 93, 252, 0.18)',
      shellGradientEnd: 'rgba(15, 23, 43, 0)',
      shellGlow: 'rgba(21, 93, 252, 0.18)',
      projectHeroStart: '#0B1424',
      projectHeroEnd: '#194058',
      projectHeroMuted: '#D1D5DC',
      projectHeroBorder: 'rgba(255, 255, 255, 0.18)',
      badgeMuted: 'rgba(21, 93, 252, 0.18)',
      successMuted: 'rgba(102, 187, 106, 0.14)',
      warningMuted: 'rgba(255, 167, 38, 0.14)',
      buttonGhost: 'rgba(255, 255, 255, 0.08)',
      ctaBackground: '#FFFFFF',
      ctaText: '#0F172B',
      ctaShadow: '0 18px 42px rgba(0, 0, 0, 0.28)',
      informationPanelBorder: 'rgba(255, 255, 255, 0.42)',
      informationPanelShadow: '0 3px 12px rgba(255, 255, 255, 0.10), 0 8px 22px rgba(0, 0, 0, 0.24)',
      disabledBackground: '#314158',
      disabledText: '#99A1AF',
      backdrop: 'rgba(2, 6, 24, 0.66)',
      panelBackdrop: 'rgba(2, 6, 24, 0.78)',
      inputSurface: 'rgba(11, 20, 36, 0.9)',
      inputBorder: 'rgba(209, 213, 220, 0.16)',
      cardOverlayStart: 'rgba(0, 0, 0, 0)',
      cardOverlayMiddle: 'rgba(0, 0, 0, 0.4)',
      cardOverlayEnd: 'rgba(0, 0, 0, 0.9)',
      mediaControlBackground: 'rgba(2, 6, 24, 0.72)',
      mediaControlBackgroundStrong: 'rgba(2, 6, 24, 0.9)',
      mediaControlBorder: 'rgba(255, 255, 255, 0.3)',
      mediaControlBorderStrong: 'rgba(255, 255, 255, 0.72)',
    },
  },
  light: {
    primary: {
      main: '#0F172B',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#F8FAFC',
      contrastText: '#0F172B',
    },
    white: {
      main: '#0F172B',
      contrastText: '#fff',
    },
    sideMenu: {
      main: '#155DFC',
      contrastText: '#FFFFFF',
    },
    blue: {
      main: '#155DFC',
      contrastText: '#FFFFFF',
    },
    student: {
      main: '#0F172B',
    },
    colors: {
      red: '#FF2D55',
      white: '#101828',
      black: '#101828',
      border: 'rgba(15, 23, 43, 0.08)',
      borderStrong: 'rgba(15, 23, 43, 0.14)',
      lightBlue: '#CCD8ED',
      grey: '#4C4C4C',
      backgroundgrey: '#F7F7F7',
      inputbackground: '#F7F7F7',
      lightgrey: '#A4A4A4',
      bluestrong: '#194058',
      shadow: 'rgba(15, 23, 43, 0.14)',
      shadowLift: 'rgba(15, 23, 43, 0.22)',
      lightshadow: 'rgba(112, 112, 112, 0.06)',
      light: 'rgba(255, 255, 255, 0.10)',
      blueopacity: 'rgba(255, 255, 255, 0.8)',
      background: '#FFFFFF',
      backgroundTransparent: 'rgba(255, 255, 255, 0)',
      backgroundSoft: 'rgba(255, 255, 255, 0.72)',
      backgroundStrong: 'rgba(255, 255, 255, 0.98)',
      surface: '#F3F4F6',
      surfaceSoft: 'rgba(243, 244, 246, 0.84)',
      surfaceElevated: '#FFFFFF',
      surfaceElevatedSoft: 'rgba(255, 255, 255, 0.92)',
      surfaceElevatedStrong: '#F8FAFC',
      cardSurface: '#FFFFFF',
      controlSurface: '#F3F6FA',
      summarySurface: '#EAF0F6',
      chipSurface: '#EEF3F8',
      cardBorder: 'rgba(29, 78, 116, 0.14)',
      text: '#0F172B',
      muted: '#4A5565',
      subdued: '#6A7282',
      contrast: '#FFFFFF',
      borderSoft: 'rgba(15, 23, 43, 0.08)',
      shadowStrong: 'rgba(15, 23, 43, 0.12)',
      cardShadow: '0 3px 12px rgba(15, 23, 43, 0.08)',
      shellGradientStart: 'rgba(21, 93, 252, 0.16)',
      shellGradientEnd: 'rgba(255, 255, 255, 0)',
      shellGlow: 'rgba(21, 93, 252, 0.12)',
      projectHeroStart: '#0F172B',
      projectHeroEnd: '#194058',
      projectHeroMuted: '#E5E7EB',
      projectHeroBorder: 'rgba(255, 255, 255, 0.18)',
      badgeMuted: 'rgba(21, 93, 252, 0.14)',
      successMuted: 'rgba(46, 125, 50, 0.1)',
      warningMuted: 'rgba(237, 108, 2, 0.1)',
      buttonGhost: 'rgba(15, 23, 43, 0.04)',
      ctaBackground: '#155DFC',
      ctaText: '#FFFFFF',
      ctaShadow: '0 10px 24px rgba(21, 93, 252, 0.24)',
      informationPanelBorder: 'rgba(15, 23, 43, 0.14)',
      informationPanelShadow: '0 5px 16px rgba(15, 23, 43, 0.12)',
      disabledBackground: '#E5E7EB',
      disabledText: '#6A7282',
      backdrop: 'rgba(15, 23, 43, 0.18)',
      panelBackdrop: 'rgba(248, 250, 252, 0.84)',
      inputSurface: '#FFFFFF',
      inputBorder: 'rgba(15, 23, 43, 0.1)',
      cardOverlayStart: 'rgba(15, 23, 43, 0.02)',
      cardOverlayMiddle: 'rgba(15, 23, 43, 0.28)',
      cardOverlayEnd: 'rgba(15, 23, 43, 0.76)',
      mediaControlBackground: 'rgba(2, 6, 24, 0.72)',
      mediaControlBackgroundStrong: 'rgba(2, 6, 24, 0.9)',
      mediaControlBorder: 'rgba(255, 255, 255, 0.3)',
      mediaControlBorderStrong: 'rgba(255, 255, 255, 0.72)',
    },
  },
};

export const getTheme = (mode = defaultThemeMode) => {
  const paletteVariant = variants[mode] || variants[defaultThemeMode];

  return createTheme({
    mode,
    palette: {
      ...sharedPalette,
      ...paletteVariant,
    },
  });
};

export const theme = getTheme(defaultThemeMode);
